import React from 'react';

export function CapinLogo({ size = 44, className = '', monogram = 'CR', imageUrl }) {
  if (imageUrl) {
    const radius = Math.max(8, size * 0.22);
    return (
      <div
        className={className}
        style={{
          width: size,
          height: size,
          borderRadius: radius,
          padding: Math.max(2, Math.round(size * 0.06)),
          background: 'linear-gradient(180deg,#10325b 0%, #0a2540 100%)',
          border: '2px solid #d4a017',
          boxShadow: '0 6px 18px rgba(10, 37, 64, 0.30)',
          display: 'grid',
          placeItems: 'center',
        }}
        aria-label="CAPIN Realty"
      >
        <img
          src={imageUrl}
          alt="CAPIN Realty"
          style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: Math.max(4, radius - 4) }}
        />
      </div>
    );
  }
  // Monogram — navy with gold border + golden "CR"
  const fontSize = Math.round(size * 0.42);
  return (
    <div
      className={className}
      style={{
        width: size,
        height: size,
        borderRadius: Math.max(8, size * 0.22),
        background: 'linear-gradient(180deg,#10325b 0%, #0a2540 100%)',
        border: '1px solid #d4a017',
        boxShadow: '0 6px 18px rgba(10, 37, 64, 0.30)',
        display: 'grid', placeItems: 'center',
        color: '#d4a017',
        fontFamily: 'Georgia, "Times New Roman", serif',
        fontWeight: 700,
        letterSpacing: 1,
        fontSize,
        lineHeight: 1,
      }}
      aria-label="CAPIN Realty"
    >
      {monogram}
    </div>
  );
}
